/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EnvironmentService from 'cio/services/environment';
import { FlyMouseEvent } from '@customerio/fly-components/types/fly-components/events';

interface LanguageSelectorSelectedLanguagesListArgs {
  languagesToAdd: string[];
  onRemove: (language: string, evt: FlyMouseEvent<HTMLButtonElement>) => unknown;
  onRemoveAll: (evt: FlyMouseEvent<HTMLButtonElement>) => unknown;
}

export default class LanguageSelectorSelectedLanguagesList extends Component<LanguageSelectorSelectedLanguagesListArgs> {
  @service environment!: EnvironmentService;

  get currentLanguageAttribute() {
    return this.environment.current.languageAttribute;
  }
}
